import * as React from "react";

import { cn } from "@/lib/utils";
import { FormFieldContext } from "@/components/ui/form-field";

export type InputProps = React.InputHTMLAttributes<HTMLInputElement>;

const Input = React.forwardRef<HTMLInputElement, InputProps>(
  ({ className, id, "aria-invalid": ariaInvalid, "aria-describedby": ariaDescribedBy, "aria-required": ariaRequired, ...props }, ref) => {
    const ctx = React.useContext(FormFieldContext);

    const resolvedId = id ?? ctx?.id;
    const resolvedInvalid = ariaInvalid ?? (ctx?.hasError ? true : undefined);
    const resolvedRequired = ariaRequired ?? (ctx?.required ? true : undefined);
    const resolvedDescribedBy =
      [ariaDescribedBy, ctx?.describedBy].filter(Boolean).join(" ") || undefined;

    return (
      <input
        ref={ref}
        id={resolvedId}
        aria-invalid={resolvedInvalid}
        aria-describedby={resolvedDescribedBy}
        aria-required={resolvedRequired}
        className={cn(
          "flex min-h-[46px] w-full rounded-xl border border-[color:var(--border-strong)] bg-[color:var(--bg-primary)] px-[13px] py-[11px] text-md text-[color:var(--text-primary)] placeholder:text-[color:var(--text-placeholder)] transition-colors focus:border-[color:var(--border-brand-alt)] focus:outline-none focus:shadow-focus disabled:cursor-not-allowed disabled:opacity-50 aria-[invalid=true]:border-[color:var(--border-error)] aria-[invalid=true]:focus:shadow-focus-error",
          className,
        )}
        {...props}
      />
    );
  },
);
Input.displayName = "Input";

export { Input };
